import React, { memo, useCallback } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Bolt from '@mui/icons-material/Bolt';
import Science from '@mui/icons-material/ScienceOutlined';
import SegmentedControl, { Segment } from './SegmentedControl';

type Environment = 'test' | 'prod';

const ENVIRONMENTS: ReadonlyArray<Segment<Environment>> = [
  { value: 'test', label: 'Test', icon: <Science /> },
  {
    value: 'prod',
    label: 'Production',
    icon: <Bolt />,
    selectedSx: { bgcolor: 'warning.main', color: 'warning.contrastText' },
  },
];

interface LabelPageHeaderProps {
  testMode: boolean;
  onTestModeChange: (testMode: boolean) => void;
}

const LabelPageHeader: React.FC<LabelPageHeaderProps> = ({ testMode, onTestModeChange }) => {
  const handleChange = useCallback((env: Environment) => onTestModeChange(env === 'test'), [onTestModeChange]);
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap', mb: 1 }}>
      <Box>
        <Typography component="h1" sx={{ fontSize: 32, fontWeight: 600, letterSpacing: '-0.02em', lineHeight: 1.15 }}>
          Print labels
        </Typography>
        <Typography sx={{ mt: 0.75, color: 'text.secondary', fontSize: 14 }}>
          Generate test or production shipping labels for a partner.
        </Typography>
      </Box>
      <SegmentedControl
        aria-label="Label environment"
        size="large"
        value={testMode ? 'test' : 'prod'}
        options={ENVIRONMENTS}
        onChange={handleChange}
      />
    </Box>
  );
};

export default memo(LabelPageHeader);
